import React from "react";
import { Grid, Paper, Typography, Divider } from "@mui/material";
import dayjs from "dayjs";
import { DAYJS_DISPLAY_FORMAT_TABLES } from "../../../context/constant";

const formatDate = (date: string) => dayjs(date).format("MMMM D, YYYY");
const ClientDetails: React.FC<{ admin: any }> = ({ admin }) => {
  const personalDetailsArr = [
    { label: "Name", value: admin.name },
    { label: "Email", value: admin.email },
    { label: "Phone Number", value: admin.phoneNumber },
    { label: "User Code", value: admin.userCode },
    { label: "Plan Name", value: admin.planName },
    {
      label: "Transaction Status",
      value: admin.transactionStatus ? "Successful" : "Failed",
    },
    { label: "Policy Count", value: admin.policyCount },
    {
      label: "Start Date",
      value: dayjs(admin.planStartDate).format(DAYJS_DISPLAY_FORMAT_TABLES),
    },
    {
      label: " End Date",
      value: dayjs(admin.planExpired).format(DAYJS_DISPLAY_FORMAT_TABLES),
    },

  ];

  const partnerDetailsArr = [
    { label: "Partner", value: admin.userLimit.partner },
    { label: "Booking", value: admin.userLimit.booking },
    { label: "Operation", value: admin.userLimit.operation },
    { label: "Account", value: admin.userLimit.account },
    { label: "RM", value: admin.userLimit.rm },
    { label: "HR", value: admin.userLimit.hr },
  ];
  return (
    <Grid container spacing={2}>
      {personalDetailsArr?.map((item, index) => (
        <Grid item lg={6} xs={12} sm={6} key={index}>
          <Paper
            elevation={4}
            sx={{
              padding: 1.5,
              borderRadius: 2,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Typography variant="body2">
              <strong style={{ color: "#57a5c7" }}>{item.label}:</strong>{" "}
              {item.value}
            </Typography>
          </Paper>
        </Grid>
      ))}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              fontSize: 20,
              fontWeight: "bold",
              color: "#027aae",
              margin: "30px 0 10px",
              borderRadius: 2,
            }}
          >
            User Limits
          </Typography>
          <Divider sx={{ marginBottom: 1 }} />
        </Grid>
        {partnerDetailsArr.map((limit, idx) => (
          <Grid item xs={12} lg={4} sm={6} md={4} key={idx}>
            <Paper
              elevation={4}
              sx={{ padding: 2, borderRadius: 2, margin: "0 0 0 15.5px" }}
            >
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                <strong style={{ color: "#57a5c7" }}>{limit.label}:</strong>{" "}
                {limit.value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default ClientDetails;
